import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";

export default function CategoryEntries() {
  return (
    <section className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
      <div className="mb-8 flex items-end justify-between gap-4">
        <div>
          <h2 className="font-heading text-xl font-extrabold text-foreground-50 md:text-2xl">分类快捷入口</h2>
          <p className="mt-2 text-sm text-foreground-400">按你感兴趣的方向，直达对应的主播视频合集。</p>
        </div>
        <Link
          to="/search"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-400 transition-colors hover:text-primary-300 sm:flex"
        >
          浏览全部 <i className="ri-arrow-right-s-line text-base" />
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-3">
        {categories.map((cat, i) => {
          const count = videos.filter((v) => v.category === cat.key).length;
          const palette = [
            { ring: "border-primary-500/40", iconBg: "bg-primary-500/15", icon: "text-primary-400", tag: "bg-primary-500/10 text-primary-300" },
            { ring: "border-secondary-500/40", iconBg: "bg-secondary-500/15", icon: "text-secondary-300", tag: "bg-secondary-500/10 text-secondary-300" },
            { ring: "border-accent-500/40", iconBg: "bg-accent-500/15", icon: "text-accent-400", tag: "bg-accent-500/10 text-accent-300" },
          ][i % 3];
          return (
            <Link
              key={cat.key}
              to={`/category/${cat.key}`}
              className={`group flex flex-col rounded-lg border ${palette.ring} bg-background-900 p-5 transition-transform duration-300 hover:-translate-y-1`}
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-12 w-12 items-center justify-center rounded-lg ${palette.iconBg} ${palette.icon}`}>
                  <i className={`${cat.icon} text-2xl`} />
                </span>
                <span className="font-label text-xs font-semibold text-foreground-500">{count} 个视频</span>
              </div>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-50 transition-colors group-hover:text-primary-400">
                {cat.name}视频
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-400">{cat.blurb}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {cat.subs.slice(0, 4).map((sub) => (
                  <span key={sub} className={`rounded-full px-2.5 py-0.5 text-xs ${palette.tag}`}>
                    {sub}
                  </span>
                ))}
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}